import alt from 'components/Dispatcher';

class UnsavedTriggerActions {
  constructor() {
    this.generateActions(
      'reset',
      'setSendToEmail',
      'setSendToInbox',
      'setSendToSlack',
      'setDamping',
      'setActionType',
      'setTrend',
      'setInequalityType',
      'setThreshold',
      'setPeriod',
      'setSubPeriod',
      'setAntiRuleId',
      'setTrendType'
    );
  }
}

export default alt.createActions(UnsavedTriggerActions);
